import React, {useCallback, useEffect, useRef} from 'react';
import './css/Header.css';
import {NavLink} from 'react-router-dom';
import logoDefault from './../../assets/images/logo/logo-with-bg.jpg';
import logoChristmas from './../../assets/images/logo/logo-with-bg-christmas.jpg';
import {Container, Nav, NavItem, Navbar, Dropdown } from "react-bootstrap";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import {IProps} from "../../interfaces/IProps";

export const Header: React.FC<IProps> = (props: IProps) => {
    const { date } = { ...props };
    const logoRef: React.MutableRefObject<string> = useRef<string>(logoDefault);

    /**
     * Depending on date, sets Christmas or default logo
     */
    const setLogo = useCallback((): void => {
        if (!!date!.month && date!.month === '01' && +date!.day < 8) {
            logoRef.current = logoChristmas;
        } else {
            logoRef.current = logoDefault;
        }
    }, [logoRef, date]);

    useEffect(() => {
        setLogo();
    }, [setLogo]);

    return (
        <div className="Header">
            <div className="h-container">
                <img
                    className="logo"
                    src={logoRef.current}
                    alt="logo"
                />
            </div>
            <Navbar collapseOnSelect
                    expand="xl"
                    variant="light"
                    className="h-navbar">
                <Container className="h-container">
                    <Navbar.Toggle aria-controls="basic-navbar-nav"
                                   className="nav-controls"
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <Nav.Link as={NavLink}
                                      exact to="/"
                                      className="navlink">
                                Головна
                            </Nav.Link>
                            <Nav.Link as={NavLink}
                                      to="/announcements"
                                      className="navlink">
                                Оголошення
                            </Nav.Link>
                            <Dropdown className="drop-custom">
                                <DropdownToggle id="dropdown-basic"
                                                className="drop-custom__toggle-custom">
                                    Про нас
                                </DropdownToggle>
                                <DropdownMenu className="drop-custom__menu-custom">
                                    <Nav.Link as={NavLink}
                                              to="/administration"
                                              className="navlink">
                                        <NavItem>
                                            Адміністрація
                                        </NavItem>
                                    </Nav.Link>
                                    <Nav.Link as={NavLink}
                                              to="/employees"
                                              className="navlink">
                                        Працівники
                                    </Nav.Link>
                                    <Nav.Link as={NavLink}
                                              to="/contacts"
                                              className="navlink">
                                        Контакти
                                    </Nav.Link>
                                </DropdownMenu>
                            </Dropdown>
                            <Nav.Link as={NavLink}
                                      to="/departments"
                                      className="navlink">
                                Відділення
                            </Nav.Link>
                            <Nav.Link as={NavLink}
                                      to="/public-info"
                                      className="navlink">
                                Публічна інформація
                            </Nav.Link>
                            <Nav.Link as={NavLink}
                                      to="/articles"
                                      className="navlink">
                                Статті
                            </Nav.Link>
                            <Nav.Link as={NavLink}
                                      to="/commands"
                                      className="navlink">
                                Накази
                            </Nav.Link>
                            <Nav.Link as={NavLink}
                                      to="/online-reception"
                                      className="navlink">
                                Інтернет-приймальня
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
